import type { Column } from "@tanstack/table-core";
import { CSSProperties } from "react";

export const getStickyStyling = <D,>(column: Column<D>): CSSProperties => {
  const isSticky = column.columnDef.meta?.sticky;

  return isSticky
    ? {
        position: "sticky",
        [isSticky]: 0,
      }
    : {};
};

export const getStickyClasses = <D,>(
  column: Column<D> | "left" | "right",
): string => {
  const isSticky =
    typeof column === "string" ? column : column.columnDef.meta?.sticky;

  return isSticky ? `sticky ${isSticky}-0` : "";
};
